 export const commonCss={
/////////////////////////Nav////////////////
    navTitleColor:'black',
    navScrollBg:"white",
    navNormalBg:"transparent",
    navCompanyNameColor:"black",

/////////////////Common////////////////////
    // blue:"#25abd1",
    blue:"#0a66c2",
    buttonBg:"#0a66c2",
    buttonText:"white",
    black:"black",
    orange:"#FF5B00",
    gray:"#8a8a8a",
    darkGray:"#4E4A67",
    white:"white",
    backgroundGray:"#F7F8F9",

////////////Home section2 Paper///////////////
    bgIcon:"rgba(255, 255, 255, 0.4)",
    countWeight:550,
    paperRadius:"1rem",
    iconBoxRaduis:"0.7rem",
    iconBoxPadding:"0.5rem",
    textWeight:450,
    iconSize:"2rem",

////////Footer/////////////////////////////////
    titleWeight:500,
    listWeight:400,
    listColor:"white",

//////////////////Service card////////////////////
    countColor:"#156076",
    countWeightCard:500,

///////////Contact Us//////////////////////////////
    
    mainTitleFontSize:"1.17em",
    mainTitleFontWeight:500,
    cardIconSize:"2rem",
    cardTitleSize:"0.9rem",
    cardTitleWeight:450,
    contactUsTextboxGray:"#cbcbcb",

    //////////// policy and terms //////////////////////
    fontFamilyPolicy:'"Nunito Sans", sans-serif',
    headerFontFamilyPolicy:'"Josefin Sans", sans-serif',
    subHeaderFontWeight:500,
    subHeaderFontSize:"1.7rem",
    contentFontWeight:300,
    contentFontSize:"1rem",
    contentVariant:"body1",

////////////////////////expert//////////////////////////
    expertColor1:"#dfc8fd",
    expertColor2:"#dcf5ff",
    expertColor3:"#dfdfdf",
    expertColor4:"#ffcad2",
    expertColor5:"#d0ffd8",



   


}